var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 5.50049L18.8803 15.5257C18.7219 18.087 18.6428 19.3678 18.0008 20.2886C17.6833 20.7438 17.2747 21.128 16.8007 21.4167C15.8421 22.0007 14.559 22.0007 11.9927 22.0007C9.42312 22.0007 8.1383 22.0007 7.17905 21.4156C6.7048 21.1264 6.296 20.7415 5.97868 20.2855C5.33688 19.3633 5.25945 18.0807 5.10461 15.5158L4.5 5.50049",
    stroke: "#FF4040",
    strokeWidth: 2.00001,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 5.50049H3",
    stroke: "#FF4040",
    strokeWidth: 2.00001,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0575 5.50004L15.3748 4.09176C14.9213 3.15627 14.6946 2.68853 14.3035 2.39682C14.2167 2.3321 14.1249 2.27454 14.0288 2.2247C13.5957 2 13.0759 2 12.0363 2C10.9706 2 10.4377 2 9.99745 2.23412C9.89986 2.28601 9.80675 2.3459 9.71906 2.41318C9.3234 2.71671 9.10239 3.20157 8.66037 4.17129L8.05469 5.50004",
    stroke: "#FF4040",
    strokeWidth: 2.00001,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 16.5006V10.5005",
    stroke: "#FF4040",
    strokeWidth: 2.00001,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 16.5006V10.5005",
    stroke: "#FF4040",
    strokeWidth: 2.00001,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.63b066b9bb6acabc3b6e224f488155fd.svg";
export { ForwardRef as ReactComponent };